<template>
    <div class="flex relative z-0 overflow-hidden border-yellow border-2 rounded-bl-none rounded-lg p-1">
      <img :src="logoImage" alt="" class=""/>
    </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "SessionCompatibilityBlock",
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  computed: {
    logoImage() {
      var theImage = this.session.productCompatibility[0].logo;
      return sanityImageBuilder
          .image(theImage)
          .height(30)
          .url();
    }
  }
};
</script>

<style scoped></style>
